import { hashHistory } from 'react-router';

// All paths
const PATHS = {
  MY_BOOKINGS: 'my_bookings',
  EXTEND: 'extend',
  OVERSTAY: 'overstay',
};

// Exported paths
export const MAIN_PATH = PATHS.MY_BOOKINGS;
export const EXTEND_PATH = PATHS.EXTEND;
export const OVERSTAY_PATH = PATHS.OVERSTAY;

// List my bookings
export const listMyBookingsPath = () => `${MAIN_PATH}`;
export const navigateToListMyBookings = () => {
  hashHistory.push(listMyBookingsPath());
};

// Show
export const showPath = (ref) => `${MAIN_PATH}/${ref}`;
export const navigateToShow = (ref) => {
  hashHistory.push(showPath(ref));
};

// Extend
export const extendMyBookingPath = (ref) => `${MAIN_PATH}/${ref}/${EXTEND_PATH}`;
export const navigateToExtendMyBooking = (ref, query = {}) => {
  hashHistory.push({
    pathname: extendMyBookingPath(ref),
    query,
  });
};

// Overstay
export const overstayMyBookingPath = (ref) => `${MAIN_PATH}/${ref}/${OVERSTAY_PATH}`;
export const navigateToRegularizeMyBooking = (ref, query = {}) => {
  hashHistory.push({
    pathname: overstayMyBookingPath(ref),
    query,
  });
};



// WEBPACK FOOTER //
// ./routes/my_bookings/navigation.js